export const searchOrders = store => (store ? store : { data: [] });
export const viewOrder = store => (store ? store : { order: {} });
